import React from 'react';

export class TitleForm extends React.Component {

  render () {
    const { object } = this.props;

    return (
      <div className="cu-ui-form-group">
        <div className="cu-ui-title">
          { object.label }
        </div>
      </div>
    );
  }
}
